module.exports = __webpack_public_path__ + "static/assets/7541a408ec69080501071d6f06d6bcce.png";